import BlogGridView from "../../../commonComponents/blogGridView";

const BlogRightSidebarContainer = () => {
  return <BlogGridView side="right" gridSize={3} />;
};

export default BlogRightSidebarContainer;
